import axios from 'axios';
import { getExpressAPIHost } from '../../utils';

const uploadFiscalBudgetData = async (formData) => {
    try {
        const response = await axios.post(`${getExpressAPIHost()}/fiscal-year-budget/upload-fiscal-year-budget/`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        throw new Error('Unable to upload file. Please contact support.');
    }
};

export default uploadFiscalBudgetData;
